var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.isIAFile
        ? _c("LexonTooltipComponent", {
            attrs: {
              icon: _vm.icon,
              message: _vm.tooltipMessage,
              position: "top",
              isWidthAuto: true,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }